// Категории операций по MCC.
//
// Провайдер присылает КОД и почти всегда пустой mccDescription — проверено на
// живой ленте: 4121, 5499, 4812, 7011, 5999 приходят с description = null.
// Поэтому человеку доставалась строка «MCC 5499», которая не значит ничего.
// Разбираем код сами: и на понятное название, и на значок.
//
// Коды — стандарт ISO 18245, их около трёхсот. Перечислять каждый бессмысленно
// и невозможно поддерживать, поэтому работаем диапазонами с точечными
// исключениями там, где отрасль сидит на одиночном коде.
//
// Порядок важен: категория, найденная раньше, побеждает. Точные коды идут
// впереди диапазонов, иначе аптека (5912) утонула бы в общей рознице.

const CATEGORIES = [
  // Еда и продукты
  { key: "grocery", codes: [5411, 5412, 5422, 5441, 5451, 5462, 5499] },
  { key: "dining", codes: [5811, 5812, 5813, 5814] },

  // Дорога
  { key: "transport", codes: [4111, 4112, 4119, 4121, 4131, 4214, 4215, 4784, 4789, 7512, 7513, 7523],
    ranges: [[3300, 3499], [7531, 7549]] },
  { key: "travel", codes: [4411, 4457, 4468, 4511, 4582, 4722], ranges: [[3000, 3299]] },
  { key: "hotel", codes: [7011, 7032, 7033], ranges: [[3500, 3999]] },
  { key: "fuel", codes: [5541, 5542, 5983] },

  // Цифровое
  { key: "telecom", codes: [4812, 4813, 4814, 4815, 4816, 4821, 4899, 4900] },
  { key: "software", codes: [5045, 5065, 5734, 5817, 5818, 7372, 7375, 7379] },
  { key: "entertainment",
    codes: [5815, 5816, 7829, 7832, 7841, 7911, 7922, 7929, 7932, 7933,
            7991, 7992, 7993, 7994, 7996, 7997, 7998, 7999] },

  // Здоровье и образование
  { key: "health", codes: [5122, 5912, 5975, 5976], ranges: [[8011, 8099]] },
  { key: "education", codes: [8351], ranges: [[8211, 8299]] },

  // Товары
  { key: "electronics", codes: [5722, 5732, 5733, 5735, 5946] },
  { key: "apparel", codes: [5931, 5944, 5977], ranges: [[5611, 5699]] },
  { key: "home", codes: [5251, 5261, 5992, 5995], ranges: [[5200, 5271], [5712, 5719]] },

  // Деньги и государство
  { key: "finance", codes: [4829, 6010, 6011, 6012, 6051, 6211, 6300, 6513] },
  { key: "government", codes: [9211, 9222, 9223, 9311, 9399, 9402, 9405] },

  // Услуги
  { key: "services",
    codes: [7311, 7333, 7338, 7342, 7349, 7361, 7392, 7399, 8398, 8911, 8931, 8999],
    ranges: [[7210, 7299], [7622, 7699], [8641, 8699]] },

  // Розница — последняя: сюда падает всё, что не опознали точнее
  { key: "retail",
    codes: [5192, 5300, 5309, 5310, 5311, 5331, 5399, 5921, 5941, 5942, 5943,
            5945, 5947, 5993, 5994, 5999],
    ranges: [[5964, 5978]] },
];

export const MCC_CATEGORY_KEYS = CATEGORIES.map((c) => c.key);

export const mccCategory = (mcc) => {
  const code = parseInt(String(mcc || "").trim(), 10);
  if (!Number.isFinite(code)) return null;
  for (const { key, codes, ranges } of CATEGORIES) {
    if (codes && codes.includes(code)) return key;
    if (ranges && ranges.some(([from, to]) => code >= from && code <= to)) return key;
  }
  return null;
};
